import { render, staticRenderFns } from "./my_awards.vue?vue&type=template&id=5a9ceeca&scoped=true"
import script from "./my_awards.vue?vue&type=script&lang=js"
export * from "./my_awards.vue?vue&type=script&lang=js"
import style0 from "./my_awards.vue?vue&type=style&index=0&id=5a9ceeca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9ceeca",
  null
  
)

export default component.exports